import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { ___, partialApply } from '@ipfabric/utils/fp/partialApply';
import { performUndoableAction } from 'components/Graph/commands/history/performUndoableAction';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import type { CollapsedNodeGroupId } from 'components/Graph/model/GraphData';
import { selectPathLookupApplied } from 'components/Graph/model/selectors/graphMetadata/selectPathLookupApplied';
import { selectAllEdgesSettings } from 'components/Graph/model/selectors/selectAllEdgesSettings';
import { createNodeCollapsingUndoableAction } from './helpers/createNodeCollapsingUndoableAction';
import { uncollapseNodes } from './helpers/uncollapseNodes';

export interface UncollapseNodeCommand {
  nodeId: CollapsedNodeGroupId;
}

export const uncollapseNode: GraphCommandFactory<UncollapseNodeCommand> =
  (cmdContext, dispatch) => (command) => {
    if (selectPathLookupApplied(cmdContext.getState())) {
      stumble('Uncollapsing nodes is not allowed for Path-lookup');
      return;
    }
    const originalGraph = cmdContext.getState().graph;
    dispatch(
      performUndoableAction,
      createNodeCollapsingUndoableAction(
        cmdContext.updateState,
        originalGraph,
        partialApply(
          uncollapseNodes,
          ___,
          selectAllEdgesSettings(cmdContext.getState()),
          new Set([command.nodeId]),
        ),
      ),
    );
  };
